import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ForecastedEnergyComponent } from './forecasted-energy.component';
import { UploaderModule } from '@component';
import { PipeModule } from '@pipe';

@NgModule({
  declarations: [ForecastedEnergyComponent],
  exports: [ForecastedEnergyComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    PipeModule,
    UploaderModule,
    MatTooltipModule,
  ],
})
export class ForecastedEnergyModule {}
